import script from "./SitePlanComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SitePlanComponent.vue?vue&type=script&setup=true&lang=ts"

import "./SitePlanComponent.vue?vue&type=style&index=0&id=8d9afbb4&scoped=true&lang=scss"

import exportComponent from "F:\\Repos\\Freelance\\site-plan-viewerBH\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d9afbb4"]])

export default __exports__